import React, { Component } from "react";
import { FiCast, FiLayers, FiUsers, FiMonitor } from "react-icons/fi";

class ServiceThree extends Component {
  render() {
    const { column } = this.props;
    // const ServiceContent = ServiceList.slice(0, this.props.item);

    return (
      <React.Fragment>
        <div className="row">
          <div className={`${column}`} key={1}>
            {/* <a href="/service-details"> */}
            <div
              className="service service__style--2"
              style={{ height: "400px" }}
            >
              <div className="icon"><i class="fas fa-laptop"></i></div>
              <div className="content">
                <h3 className="title">Website Development</h3>
                <p>
                  Having a website and online presence strategy allows you to
                  market your buisness online.
                </p>
              </div>
            </div>
            {/* </a> */}
          </div>

          <div className={`${column}`} key={2}>
            {/* <a href="/service-details"> */}
            <div
              className="service service__style--2"
              style={{ height: "400px" }}
            >
              <div className="icon"><i class="fas fa-mobile-alt"></i></div>
              <div className="content">
                <h3 className="title">Mobile App Development</h3>
                <p>
                  An app is a way to bring your consumer closer to your products
                  or services.
                </p>
              </div>
            </div>
            {/* </a> */}
          </div>
          <div className={`${column}`} key={3}>
            {/* <a href="/service-details"> */}
            <div
              className="service service__style--2"
              style={{ height: "400px" }}
            >
              <div className="icon"><i class="fas fa-pencil-ruler"></i></div>
              <div className="content">
                <h3 className="title">
                  UI<span style={{ fontFamily: "QuickSand" }}><b>/</b></span>UX
                  Designing
                </h3>
                <p>
                  A good user experience and interface are significant for easy
                  product usability.
                </p>
              </div>
            </div>
            {/* </a> */}
          </div>
          <div className={`${column}`} key={4}>
            {/* <a href="/service-details"> */}
            <div
              className="service service__style--2"
              style={{ height: "400px" }}
            >
              <div className="icon"><i class="fas fa-chalkboard-teacher"></i></div>
              <div className="content">
                <h3 className="title">Digital Marketing</h3>
                <p>
                  Mediocre marketers think in terms of campaigns. Great
                  marketers focus on growth frameworks.
                </p>
              </div>
            </div>
            {/* </a> */}
          </div>
          <div className={`${column}`} key={5}>
            {/* <a href="/service-details"> */}
            <div
              className="service service__style--2"
              style={{ height: "400px" }}
            >
              <div className="icon"><i class="fas fa-users"></i></div>
              <div className="content">
                <h3 className="title">IT Support</h3>
                <p>
                  Ensuring your data is stored in a secure environment and is
                  easily accessible to authorized users.
                </p>
              </div>
            </div>
            {/* </a> */}
          </div>
          <div className={`${column}`} key={6}>
            {/* <a href="/service-details"> */}
            <div
              className="service service__style--2"
              style={{ height: "400px" }}
            >
              <div className="icon"><i class="fas fa-cube"></i></div>
              <div className="content">
                <h3 className="title">
                  Strategy<span style={{ fontFamily: "QuickSand" }}><b> & </b></span>
                  Branding
                </h3>
                <p>
                  Executing a memorable impression on target market, resulting strong recognition & loyalty for the brand.
                </p>
              </div>
            </div>
            {/* </a> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default ServiceThree;
